// extracted by mini-css-extract-plugin
export default {"logo":"logo_logo__6uAXs","shrinkLetters":"logo_shrinkLetters__6dp4i"};